import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: '60vh',
    backgroundColor: theme.palette.grey[50],
    padding: theme.spacing(3),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1),
    },
  },
  header: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: '0 1px 3px rgba(0,0,0,0.12)',
    borderBottom: `1px solid ${theme.palette.grey[200]}`,
    marginBottom: theme.spacing(3),
  },
  title: {
    fontWeight: 700,
    color: theme.palette.grey[900],
  },
  subtitle: {
    color: theme.palette.grey[600],
    marginTop: theme.spacing(1),
  },
  searchSection: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: 8,
    padding: theme.spacing(3),
    marginBottom: theme.spacing(3),
    boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
  },
  searchField: {
    '& .MuiOutlinedInput-root': {
      borderRadius: 8,
    },
  },
  filterSection: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: 12,
    padding: theme.spacing(3),
    marginBottom: theme.spacing(3),
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
    border: '1px solid #e3f2fd',
    transition: 'all 0.3s ease-in-out',
    '&:hover': {
      boxShadow: '0 4px 12px rgba(25,118,210,0.12)',
    },
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(2),
      marginBottom: theme.spacing(2),
      borderRadius: 8,
    },
  },
  formControl: {
    minWidth: 120,
    marginRight: theme.spacing(2),
    '& .MuiOutlinedInput-root': {
      borderRadius: 8,
    },
  },
  budgetCard: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: 8,
    boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
    border: `1px solid ${theme.palette.grey[200]}`,
    cursor: 'pointer',
    transition: 'all 0.3s ease-in-out',
    '&:hover': {
      boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
      transform: 'translateY(-2px)',
    },
    [theme.breakpoints.down('sm')]: {
      borderRadius: 8,
      '&:hover': {
        transform: 'none',
      },
    },
  },
  statusChip: {
    fontWeight: 600,
    borderRadius: 12,
    border: '1px solid',
  },
  clientInfo: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  valueText: {
    fontWeight: 700,
    color: theme.palette.success.main,
  },
  actionText: {
    color: theme.palette.primary.main,
    fontWeight: 600,
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    transition: 'all 0.2s ease-in-out',
  },
  pagination: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(2),
    '& .MuiPagination-ul': {
      flexWrap: 'wrap',
      justifyContent: 'center',
    },
    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing(2),
      '& .MuiPaginationItem-root': {
        margin: '2px',
        minWidth: 32,
        height: 32,
      },
    },
  },
  iconSmall: {
    fontSize: 16,
  },
  productIcon: {
    fontSize: 20,
    color: theme.palette.primary.main,
  },
}));
